<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="main">
      <!-- <div class="topBanner" v-if="top_adv != undefined && top_adv != null" @click="topAdvClick(top_adv.param,top_adv.url)">
        <img :src="top_adv.image" alt />
        <span>广告</span>
      </div> -->

      <Topadv :keys="keywords"></Topadv>

      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span style="color:#0091ff">音频</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="list">
            <span class="prev" v-if="infoList.length > 3" @click="prev">
              <img src="@/assets/img/icon_prev.png" alt srcset />
            </span>
            <ul class="ulList">
              <li
                v-for="(item, i) in infoList"
                :key="i"
                @click="typeDetail(item)"
              >
                <div class="img">
                  <img :src="item.cover_url" alt />
                  <div>
                    <img src="@/assets/img/watch.png" alt />
                    <span>{{ item.visit_times }}</span>
                  </div>
                </div>
                <div class="cont-box">
                  <p>{{ item.name }}</p>
                  <div>{{ item.summary }}</div>
                </div>
              </li>
            </ul>
            <span class="next" v-if="infoList.length > 3" @click="next">
              <img src="@/assets/img/icon_next.png" alt srcset />
            </span>
          </div>
          <div class="hot">
            <p class="tit">热门推荐</p>
            <ul>
              <li v-for="(item, i) in hotList" :key="i" @click="detail(item)">
                <div class="img">
                  <img :src="item.cover_url" alt />
                </div>
                <div class="hot-box">
                  <p>{{ item.title }}</p>
                  <div class="cont">{{ item.summary }}</div>
                  <div class="num">
                    <div>
                      <img src="@/assets/img/play1.png" alt />
                      <span>{{ item.visit_times }}</span>
                    </div>
                    <div>
                      <img src="@/assets/img/clock.png" alt />
                      <span>{{ item.audio_duration | timeToString }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="morePage" v-if="show_page">
              <div @click="moreData">
                <p>加载更多资讯</p>
                <div>
                  <img src="@/assets/img/more.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart :keys="keywords"></Wechart>
          <!-- 右侧广告 -->
          <RightAdv keys="音频" :advId="651" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getone, advclick} from "@/api/adv";
import Wechart from "@/components/wechart";
import Topadv from "@/components/topadv";
import { getRadioList, getHotRecommendList } from "@/api/radio";
import RightAdv from "@/components/rightadv.vue";
import { getTdkList} from "@/api/tdk";

export default {
  name: "radio",
  components: {
    Wechart,
    Topadv,
    RightAdv
  },
  data() {
    return {
      keywords: "音频",
      show_page: true,
      page: 1,
      per: 5,
      infoList: [],
      hotList: [],
      liIndex: 0,
      loading: true,
      //顶部广告
      top_adv: {
        image: "",
        url: "",
        param: ""
      }
    };
  },
  methods: {
    moreData() {
      this.getHotList();
    },
    typeDetail(scope) {
      this.$router.push({
        name: "radio_detail",
        params: { id: scope.id, title: scope.title }
      });
    },
    detail(scope) {
      this.$router.push({
        name: "hot_detail",
        params: { id: scope.id, title: scope.title }
      });
    },
    getHotList() {
      var params = {
        page: this.page,
        per: this.per,
        type: "android"
      };
      getHotRecommendList(params).then(res => {
        this.hotList = this.hotList.concat(res.data.data);
        if (this.page >= res.data.meta.total_pages) {
          this.show_page = false;
        } else {
          this.page++;
        }
      });
    },
    //上一个
    prev() {
      if (this.liIndex > 0) {
        $(".ulList li")
          .eq(this.liIndex - 1)
          .show();
        this.liIndex--;
      } else {
        // this.$message.error("没有上一个");
      }
    },
    // 下一个
    next() {
      if (this.infoList.length - this.liIndex > 3) {
        $(".ulList li")
          .eq(this.liIndex)
          .hide();
        this.liIndex++;
      }
    },
    //右侧广告跳转
    rightAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    },
    //顶部广告跳转
    topAdvClick(data, url) {
      advclick(data, "home");
      window.open(url, "_blank");
    }
  },
  created() {
    getTdkList({column:3}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.$ba([
      ["ptype", "list"],
      ["acategory", "radio"],
      ["acname", "音频"],
      ["atype", "radio"]
    ]);
    getRadioList().then(res => {
      this.loading = false;
      this.infoList = res.data.data;
    });
    this.getHotList();
    //右侧广告
    getone(651, "音频").then(res => {
      if (res != "" && res.data != "" && res.data.return_code == 0) {
        try {
          if (res.data.direct_creatives_info[0].adsold) {
            this.right_adv.url = res.data.direct_creatives_info[0].click_url;
            var img = res.data.direct_creatives_info[0].user_define_content;
            img = JSON.parse(img);
            this.right_adv.image = img.imgUrl;
            this.right_adv.param = res.data.direct_creatives_info[0];
          }
        } catch (error) {}
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}
.list {
  position: relative;
  ul {
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 30px;
    display: -webkit-box;
    overflow: hidden;
    li {
      background: #ffffff;
      width: 31%;
      margin-right: 30px;
      cursor: pointer;
      .img {
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          vertical-align: top;
        }
        div {
          position: absolute;
          bottom: 10%;
          left: 10%;
          background: #333;
          color: #ffffff;
          border-radius: 12px;
          padding: 2px 10px;
          opacity: 0.8;
          img {
            width: 10px;
            height: 12px;
            vertical-align: middle;
          }
          span {
            vertical-align: middle;
            font-size: 12px;
          }
        }
      }
      .cont-box {
        padding: 28px 30px 26px 29px;
        p {
          font-size: 20px;
          line-height: 20px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        div {
          color: #999999;
          font-size: 13px;
          line-height: 22px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          margin-top: 5px;
        }
      }
    }
  }
  .prev {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 10px;
    top: 31%;
    z-index: 2;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .next {
    position: absolute;
    right: 10px;
    top: 31%;
    z-index: 2;
    width: 40px;
    height: 40px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.hot {
  padding: 30px;
  margin-bottom: 60px;
  background: #ffff;
  .tit {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 20px;
  }
  ul {
    li {
      margin-bottom: 30px;
      display: flex;
      cursor: pointer;
      height: 140px;
      .img {
        margin-right: 30px;
        // width: 18%;
        height: 140px;
        width: 140px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .hot-box {
        position: relative;
        width: 80%;
        p {
          font-size: 20px;
        }
        .cont {
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          margin-top: 14px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .num {
          display: flex;
          font-size: 14px;
          line-height: 20px;
          color: #999999;
          position: absolute;
          bottom: 2px;
          width: 100%;
          div {
            margin-right: 10%;
            span {
              margin-left: 10px;
            }
          }
          div:last-child {
            span {
              margin-left: 14px;
            }
          }
        }
      }
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}

.rightTop {
  position: relative;
  width: 320px;
  height: 250px;
  background: #fff;

  span {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    color: #fff;
    background: #33333380;
    line-height: 20px;
    padding: 0 12px;
  }
}

// //新增广告样式
// .topBanner {
//   position: relative;
//   margin: 30px 0;
//   display: block;
//   // border: 1px solid;
//   background: #fff;
//   height: 90px;
//   span {
//     position: absolute;
//     left: 0;
//     bottom: 0;
//     font-size: 12px;
//     color: #fff;
//     background: #33333380;
//     line-height: 20px;
//     padding: 0 12px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/radio/index.vue